import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
export const SwalSuccess = (props) => {
    const hideModel = () => {
        props.onHide();
    };
    const closeModel = () => {
        props.onClose();
    };
    const responseClose = (props) => {
        props.responseOnOk()
    };
    return (
        <div>
            <Modal
                show={props.show}
                onHide={props.onClose}
                backdrop="static"
                keyboard={false}
                centered
            >
                <Modal.Body className="text-center my-6">
                    <div className="screenAlert-icon screenAlert-success animate">
                        <span className="screenAlert-line screenAlert-tip animateSuccessTip"></span>
                        <span className="screenAlert-line screenAlert-long animateSuccessLong"></span>
                        <div className="screenAlert-placeholder"></div>
                        <div className="screenAlert-fix"></div>
                    </div>
                    <p className="font-size-h4 font-weight-bold my-10">{props.message ? props.message : "Success"}</p>
                   {props.onHide ? <Button
                        variant="secondary"
                        onClick={() => hideModel(props)}
                        className="mr-4"
                    >
                        Cancel
                    </Button> : ""}
                    <Button className="px-8"
                        variant="primary"
                        onClick={() => {props.responseOnOk ? responseClose(props): closeModel(props) }}
                    >
                       Ok
                    </Button>
                </Modal.Body>
            </Modal>
        </div>
    );
};
